import { render } from "./ToastMessage.vue?vue&type=template&id=b70e8c90&scoped=true"
import script from "./ToastMessage.vue?vue&type=script&lang=js"
export * from "./ToastMessage.vue?vue&type=script&lang=js"

import "./ToastMessage.vue?vue&type=style&index=0&id=b70e8c90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b70e8c90"

export default script